import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MerchantsRoutingModule } from './merchants-routing.module';
import { MerchantCESComponent } from './crud-ces/crud-ces.component';
import { MerchantIndexComponent } from './crud-index/crud-index.component';
import { MerchantIndexSelectComponent } from './crud-index/crud-index-select.component';
import { MerchantTransactionsComponent } from './components/merchant-transactions/merchant-transactions.component';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { NgxMaskModule } from 'ngx-mask';
import { MerchantUsersFormComponent } from './merchant-users/merchant-users-form.component';
import { MerchantUsersIndexComponent } from './merchant-users/merchant-users-index.component';

@NgModule({
  declarations: [
    MerchantCESComponent,
    MerchantIndexComponent,
    MerchantIndexSelectComponent,
    MerchantTransactionsComponent,
    MerchantUsersIndexComponent,
    MerchantUsersFormComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    MerchantsRoutingModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
    SharedModule,
    DynamicFormModule,
    FormsModule,
    ReactiveFormsModule,
    FieldsModule,
    TableResponsiveModule,
    NgxMaskModule.forRoot()
  ]
})
export class MerchantsModule { }
